import {AnyAction, Dispatch} from 'redux';
import {connect} from 'react-redux';
import ModalComponent from '../../common/components/modal/ModalComponent';
import * as ModalActions from '../actions/ModalActions';
import {State} from '../types/mx/reducers';
import {ModalDispatchProps, ModalState} from '../../common/types/reducers';

const mapStateToProps = (state: State, ownProps: {}): ModalState => ({
    isVisible: state.ui.modal.isVisible,
    isVisible2: state.ui.modal.isVisible2,
    header: state.ui.modal.header,
    header2: state.ui.modal.header2,
    content: state.ui.modal.content,
    content2: state.ui.modal.content2,
    footer: state.ui.modal.footer,
    footer2: state.ui.modal.footer2,
    options: state.ui.modal.options,
    options2: state.ui.modal.options2
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): ModalDispatchProps => ({
    closeModal: isFirstModal => dispatch(ModalActions.CLOSE_MODAL_ACTION.action(isFirstModal)),
    retry: retryAction => dispatch({...retryAction})
});

const mergeProps = (stateProps: ModalState, dispatchProps: ModalDispatchProps) => ({
    ...stateProps,
    ...dispatchProps,
    footer: stateProps.footer ? {
        ...stateProps.footer,
        onPressCancelBtn: () => {
            (stateProps.footer && stateProps.footer.onPressCancelBtn) && stateProps.footer.onPressCancelBtn();
            dispatchProps.closeModal(true);
        },
        onPressAcceptBtn: () => {
            (stateProps.footer && stateProps.footer.onPressAcceptBtn) && stateProps.footer.onPressAcceptBtn();
            (stateProps.footer && stateProps.footer.retryAction) && dispatchProps.retry(stateProps.footer.retryAction);
            dispatchProps.closeModal(true);
        }
    } : null,
    footer2: stateProps.footer2 ? {
        ...stateProps.footer2,
        onPressCancelBtn: () => {
            (stateProps.footer2 && stateProps.footer2.onPressCancelBtn) && stateProps.footer2.onPressCancelBtn();
            dispatchProps.closeModal(false);
        },
        onPressAcceptBtn: () => {
            (stateProps.footer2 && stateProps.footer2.onPressAcceptBtn) && stateProps.footer2.onPressAcceptBtn();
            (stateProps.footer2 && stateProps.footer2.retryAction)
            && dispatchProps.retry(stateProps.footer2.retryAction);
            dispatchProps.closeModal(false);
        }
    } : null
});

const ModalContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(ModalComponent);

export default ModalContainer;